import { render, staticRenderFns } from "./NewDiagnosisDialog.vue?vue&type=template&id=ab54aef6&scoped=true&"
import script from "./NewDiagnosisDialog.vue?vue&type=script&lang=js&"
export * from "./NewDiagnosisDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab54aef6",
  null
  
)

export default component.exports